// eslint-disable-next-line import/prefer-default-export
export const ABOUT_PAGE_LOAD = 'about-manulife-id';
